// Full navigation list — used by mobile menu and footer
export const NAV_LINKS = [
  { id: "about", label: "О компании" },
  { id: "products", label: "Продукция" },
  { id: "furniture", label: "Промышленная мебель" },
  { id: "motors", label: "Электродвигатели" },
  { id: "advantages", label: "Преимущества" },
  { id: "process", label: "Как работаем" },
  { id: "faq", label: "Вопросы" },
  { id: "contacts", label: "Контакты" },
];

// Compact subset — used by desktop top navigation to prevent wrapping
export const TOP_NAV_LINKS = [
  { id: "about", label: "О компании" },
  { id: "products", label: "Продукция" },
  { id: "furniture", label: "Мебель" },
  { id: "motors", label: "Двигатели" },
  { id: "advantages", label: "Преимущества" },
  { id: "contacts", label: "Контакты" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const offset = 90;
  const top = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: "smooth" });
};

export const mailto = (subject) =>
  `mailto:bizoralogistikgroup@yandex.ru?subject=${encodeURIComponent(subject)}`;
